import { render, staticRenderFns } from "./TagWithIcon.vue?vue&type=template&id=5d2eda39&scoped=true&"
import script from "./TagWithIcon.vue?vue&type=script&lang=js&"
export * from "./TagWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./TagWithIcon.vue?vue&type=style&index=0&id=5d2eda39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2eda39",
  null
  
)

export default component.exports